import { render, staticRenderFns } from "./HomepageIntro.vue?vue&type=template&id=929e9f22&scoped=true&"
import script from "./HomepageIntro.vue?vue&type=script&lang=js&"
export * from "./HomepageIntro.vue?vue&type=script&lang=js&"
import style0 from "./HomepageIntro.vue?vue&type=style&index=0&id=929e9f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929e9f22",
  null
  
)

export default component.exports